// Messages for portal/QuoteDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.quote_detail.head': '{ref} — Portal',
  'portal.quote_detail.back': 'Back to quotes',
  'portal.quote_detail.transit_days': '{days} days',
  'portal.quote_detail.lane_transit': '{origin} → {destination} · {transit} transit',
  'portal.quote_detail.download_pdf': 'Download PDF',
  'portal.quote_detail.breakdown': 'Quote breakdown',
  'portal.quote_detail.total': 'Total',
  'portal.quote_detail.breakdown_note':
    'This is your agreed all-in price. Subject to space & GRI; valid until the date shown.',
  'portal.quote_detail.terms': 'Terms',
  'portal.quote_detail.tab.chat': 'Messages',
  'portal.quote_detail.tab.docs': 'Documents',
  'portal.quote_detail.converted.title': 'This quote is now a shipment',
  'portal.quote_detail.converted.body':
    'Messages and documents moved to the shipment below. Continue the conversation there.',
  'portal.quote_detail.converted.view_shipment': 'Open shipment',
  'portal.quote_detail.incoterm_payment': 'Incoterm: {incoterm} · Payment: Net 30',
  'portal.quote_detail.estimated_transit': 'Estimated transit: {transit}',
  'portal.quote_detail.summary': 'Summary',
  'portal.quote_detail.row.lane': 'Lane',
  'portal.quote_detail.row.mode': 'Mode',
  'portal.quote_detail.row.transit': 'Transit',
  'portal.quote_detail.row.total': 'Total',
  'portal.quote_detail.row.quoted_on': 'Quoted on',
  'portal.quote_detail.row.valid_until': 'Valid until',
  'portal.quote_detail.accept': 'Accept quote',
  'portal.quote_detail.decline': 'Decline',
  'portal.quote_detail.status_note': 'This quote is {status}.',
}

export const zhTW = {
  'portal.quote_detail.head': '{ref} — 客戶入口',
  'portal.quote_detail.back': '返回報價列表',
  'portal.quote_detail.transit_days': '{days} 天',
  'portal.quote_detail.lane_transit': '{origin} → {destination} · 運送 {transit}',
  'portal.quote_detail.download_pdf': '下載 PDF',
  'portal.quote_detail.breakdown': '報價明細',
  'portal.quote_detail.total': '總計',
  'portal.quote_detail.breakdown_note':
    '這是您的議定全包價格。視艙位與 GRI 而定；於所示日期前有效。',
  'portal.quote_detail.terms': '條款',
  'portal.quote_detail.tab.chat': '訊息',
  'portal.quote_detail.tab.docs': '文件',
  'portal.quote_detail.converted.title': '此報價已成為貨件',
  'portal.quote_detail.converted.body': '訊息與文件已移至以下貨件，請於該處繼續對話。',
  'portal.quote_detail.converted.view_shipment': '開啟貨件',
  'portal.quote_detail.incoterm_payment': '貿易條件：{incoterm} · 付款：Net 30',
  'portal.quote_detail.estimated_transit': '預估運送時間：{transit}',
  'portal.quote_detail.summary': '摘要',
  'portal.quote_detail.row.lane': '航線',
  'portal.quote_detail.row.mode': '模式',
  'portal.quote_detail.row.transit': '運送時間',
  'portal.quote_detail.row.total': '總計',
  'portal.quote_detail.row.quoted_on': '報價日期',
  'portal.quote_detail.row.valid_until': '有效至',
  'portal.quote_detail.accept': '接受報價',
  'portal.quote_detail.decline': '拒絕',
  'portal.quote_detail.status_note': '此報價{status}。',
}
